var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "GooglePay",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93.909,
    height: 38.668,
    viewBox: "0 0 93.909 38.668",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M28.226,29.4V18.052h5.857a8.449,8.449,0,0,0,6.077-2.39l.4-.4a8.17,8.17,0,0,0-.4-11.437,8.359,8.359,0,0,0-6.077-2.435h-9.4V29.4Zm0-14.788V4.828h5.946a4.8,4.8,0,0,1,3.391,1.385,4.979,4.979,0,0,1,.11,6.947,4.6,4.6,0,0,1-3.5,1.452ZM57.093,11.73a8.785,8.785,0,0,0-6.209-2.122,8.539,8.539,0,0,0-7.574,3.73l3.127,1.988a5.374,5.374,0,0,1,4.69-2.547A5.11,5.11,0,0,1,54.538,14.1a4.225,4.225,0,0,1,1.453,3.194v.826a10.553,10.553,0,0,0-5.2-1.161,9.2,9.2,0,0,0-5.923,1.765,5.754,5.754,0,0,0-2.224,4.736,5.96,5.96,0,0,0,2.092,4.691,7.538,7.538,0,0,0,5.218,1.876,6.749,6.749,0,0,0,5.857-3.284h.154V29.4h3.391V17.583A7.6,7.6,0,0,0,57.093,11.73ZM47.471,25.87A2.913,2.913,0,0,1,46.3,23.525a3.138,3.138,0,0,1,1.432-2.613,6.073,6.073,0,0,1,3.611-1.05,7.024,7.024,0,0,1,4.625,1.318,5.308,5.308,0,0,1-1.762,3.954,5.594,5.594,0,0,1-3.986,1.675A4.29,4.29,0,0,1,47.471,25.87ZM66.979,37.821,78.825,10.233H74.971l-5.482,13.76h-.066l-5.615-13.76H59.955l7.773,17.938-4.4,9.65Z",
    transform: "translate(15.085 0.847)",
    fill: "#c9c9c9",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M25.057,11.442a20.159,20.159,0,0,0-.264-3.261H9.843v6.188h8.565a7.456,7.456,0,0,1-3.171,4.892v4.021h5.108A15.807,15.807,0,0,0,25.057,11.442Z",
    transform: "translate(6.016 5)",
    fill: "#c9c9c9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M15.214,24.9a15.038,15.038,0,0,0,10.5-3.887L20.608,16.99a9.4,9.4,0,0,1-5.394,1.541,9.5,9.5,0,0,1-8.9-6.634H1.056v4.155A15.812,15.812,0,0,0,15.214,24.9Z",
    transform: "translate(0.645 7.271)",
    fill: "#c9c9c9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M6.964,15.8a9.837,9.837,0,0,1,0-6.165V5.5H1.7a16.152,16.152,0,0,0,0,14.43Z",
    transform: "translate(0 3.364)",
    fill: "#c9c9c9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M15.214,6.367A8.465,8.465,0,0,1,21.291,8.78l4.536-4.6A15.182,15.182,0,0,0,15.214,0,15.833,15.833,0,0,0,1.056,8.869l5.262,4.155A9.494,9.494,0,0,1,15.214,6.367Z",
    transform: "translate(0.645)",
    fill: "#c9c9c9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/GooglePay.59ef7c4f495b2d8e11b4c3d9c774388c.svg";
export { ForwardRef as ReactComponent };